import Anchor from "../../../../../lib/html5-software-library/src/ranj/layout/Anchor";
import DialogPlayerMediator from "../../../ngt/dialog/view/DialogPlayerMediator";
import DisplayObjectUtil from "../../util/DisplayObjectUtil";

export default class DialogScreenMediator extends DialogPlayerMediator {
    constructor(target, dispatcher, soundManager, assetLibrary, assetLocator, assetLoadService, scenarioLibrary,
        mediatorManager, npcModel, config, layoutManager, clickEaterFactory, languagePack) {

        super(target, dispatcher, soundManager, assetLibrary, assetLocator, assetLoadService, scenarioLibrary,
            mediatorManager, npcModel, config, layoutManager, clickEaterFactory, languagePack);

        this._assetLibrary = assetLibrary;
    }

    _handleOverlayImageContent(content) {
        const imageId = content.getImage();
        this._changeImage(this._target.ImagePlaceholder, imageId);
        this.getDialogPlayer().contentCompleted(content);
    }

    _changeImage(imageContainer, imageId) {
        return new Promise(resolve => {
            const childrenToRemove = [...imageContainer.children]; // shallow copy as we want to remove the elements that were children at this specific moment

            const bitmap = this._assetLibrary.tryGetBitmapFromImageId(imageId);
            DisplayObjectUtil.anchorDisplayObject(bitmap, Anchor.TL);
            bitmap.alpha = 0;

            imageContainer.addChild(bitmap);

            createjs.Tween.get(bitmap)
                .to({ alpha: 1 }, 450, createjs.Ease.sineOut)
                .call(resolve);

            childrenToRemove.forEach(c => {
                createjs.Tween.get(c)
                    .wait(150)
                    .to({ alpha: 0 }, 300, createjs.Ease.sineIn)
                    .call(() => imageContainer.removeChild(c));
            });
        });
    }

}